import React, { useState } from "react";
import { Card, CardContent, Typography, Button, Box } from "@material-ui/core";
import EntityGapList from "./EntityGapList";
import PackagingGapList from "./PackagingGapList";
import ArticleGapPanel from "./ArticleGapPanel";
import MaterialTracePanel from "./MaterialTracePanel";
import SupplierTracePanel from "./SupplierTracePanel";

// "Resolver" reworked as three entity tabs (Artículos · Materiales · Proveedores). Each lists its
// entities with their gaps; material/supplier add a dependency column. Clicking an entity opens its
// traceability: article → the full article panel (Trazabilidad tab), material → composition,
// supplier → where-used.
const TABS = [
  { key: "article", label: "Artículos" },
  { key: "material", label: "Materiales" },
  { key: "packaging", label: "Packaging" },
  { key: "supplier", label: "Proveedores" },
];

const EntityGapsPanel = ({ api, projectId, contracted, onChanged }) => {
  const [tab, setTab] = useState("article");
  const [open, setOpen] = useState(null); // { type, id, name, gaps }
  const [reloadKey, setReloadKey] = useState(0); // bump → EntityGapList refetches (counts update)

  const onOpenEntity = (type, id, name, gaps) => setOpen({ type, id, name, gaps: gaps || [] });
  const close = () => setOpen(null);

  // A gap resolved inside a ficha → reload the entity list counts and bubble up (Resumen/shared data).
  const handleChanged = () => {
    setReloadKey((k) => k + 1);
    if (onChanged) onChanged();
  };

  return (
    <Card>
      <CardContent>
        <Typography variant="h6" gutterBottom>
          Datos por entidad
        </Typography>
        <Typography variant="body2" color="textSecondary" gutterBottom>
          Busca y ordena artículos, materiales o proveedores. Selecciona una entidad para ver sus pendientes y trazabilidad.
        </Typography>

        <Box display="flex" style={{ gap: 8, margin: "12px 0 16px" }}>
          {TABS.map((t) => (
            <Button
              key={t.key}
              size="small"
              variant={tab === t.key ? "contained" : "outlined"}
              color="primary"
              onClick={() => setTab(t.key)}
            >
              {t.label}
            </Button>
          ))}
        </Box>

        {tab === "packaging" ? (
          <PackagingGapList api={api} projectId={projectId} contracted={contracted} onChanged={handleChanged} reloadKey={reloadKey} />
        ) : (
          <EntityGapList api={api} projectId={projectId} groupBy={tab} onOpenEntity={onOpenEntity} contracted={contracted} reloadKey={reloadKey} />
        )}

        {open && open.type === "article" && (
          <ArticleGapPanel
            api={api}
            articleId={open.id}
            articleName={open.name}
            contracted={contracted}
            initialTab="trace"
            onClose={close}
            onChanged={handleChanged}
          />
        )}
        {open && open.type === "material" && (
          <MaterialTracePanel api={api} materialId={open.id} materialName={open.name} gaps={open.gaps} contracted={contracted} onClose={close} onChanged={handleChanged} />
        )}
        {open && open.type === "supplier" && (
          <SupplierTracePanel api={api} supplierId={open.id} supplierName={open.name} gaps={open.gaps} contracted={contracted} onClose={close} onChanged={handleChanged} />
        )}
      </CardContent>
    </Card>
  );
};

export default EntityGapsPanel;
